module.exports = __webpack_public_path__ + "img/GD.c15511a1.svg";